import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'src/app/models/message';
import { Biblio } from 'src/app/models/obs/biblio';
import { AccessService } from 'src/app/services/access.service';
import { BiblioService } from 'src/app/services/obs/biblio.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';

@Component({
  selector: 'app-admbiblio-list',
  templateUrl: './admbiblio-list.component.html',
  styleUrl: './admbiblio-list.component.scss'
})
export class AdmbiblioListComponent implements OnInit {
  isBlockedTier3: boolean = false;
  biblio: Biblio[] = [];
  msg: Message;
  idtier3Selected: string = null;
  selectedIds: number[] = [];

  constructor(
    private biblioS: BiblioService,
    private activedRoute: ActivatedRoute,
    private accesService: AccessService,
    private ts: TokenStorageService,
    private tier3Service: Tier3Service
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.idtier3Selected = params['idtier3'];
    this.getBiblio4t1(params['idtier3']);
    this.getPermission();
    this.getIsBlockedTier3(Number(this.idtier3Selected))
  }

  //bandera que controla la creacion de contenido
  accessMP: boolean = false
  //bandera que controla la eliminacion de contenido
  accessME: boolean = false
  //bandera que controla la eliminacion de contenido
  accessMD: boolean = false
  /* Permite determinar si el usuario actual tiene permiso para el modulo */
  inf = {}
  idTier3 = {}

  getPermission() {

    this.idTier3['id'] = this.activedRoute.snapshot.params['idtier3'] * 1;
    const data1 = this.idTier3;

    this.tier3Service.getIdTier1(data1).subscribe({
      next: res => {

        if (res['data'].idtier1 == 1 || res['data'].idtier1 == 5 || res['data'].idtier1 == 11 || res['data'].idtier1 == 12 || res['data'].idtier1 == 13 || res['data'].idtier1 == 15 || res['data'].idtier1 == 16) {
          this.inf['accessId'] = 1; //tendencia
        }
        if (res['data'].idtier1 == 2 || res['data'].idtier1 == 6 || res['data'].idtier1 == 22) {
          this.inf['accessId'] = 2;//riesgo
        }
        if (res['data'].idtier1 == 3 || res['data'].idtier1 == 4 || res['data'].idtier1 == 23) {
          this.inf['accessId'] = 3;//Oportunidad
        }
        if (res['data'].idtier1 == 7 || res['data'].idtier1 == 17) {
          this.inf['accessId'] = 4;//megatendencia
        }
        if (res['data'].idtier1 == 9 || res['data'].idtier1 == 14 || res['data'].idtier1 == 19) {
          this.inf['accessId'] = 5;//esceneario
        }
        if (res['data'].idtier1 == 8 || res['data'].idtier1 == 16 || res['data'].idtier1 == 17 || res['data'].idtier1 == 18 || res['data'].idtier1 == 19 || res['data'].idtier1 == 24) {
          this.inf['accessId'] = 6;//eventos futuros
        }
        if (res['data'].idtier1 == 20) {
          this.inf['accessId'] = 9;//fuerza
        }
        if (res['data'].idtier1 == 21) {
          this.inf['accessId'] = 10;//tecnologia  
        }


        this.inf['userId'] = this.ts.getUser().id;
        const data = this.inf;

        this.accesService.getPermissionUser(data).subscribe({
          next: res => {
            this.accessMP = res['result'].createBiblio;
            this.accessME = res['result'].editBiblio;
            this.accessMD = res['result'].deleteBiblio;
          },
          error: err => {
            this.msg = err;
          }
        });
      },
      error: err => {
        this.msg = err;
      }
    })
  }

  getBiblio4t1(id: string) {
    this.biblioS.get4T3Adm(id).subscribe(
      res => {
        this.biblio = res['data'].map(item => ({ ...item, selected: false }));
      },
      err => {
        this.msg = err;
      }
    );
  }

  toggleSelectAll(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.biblio.forEach(item => {
      item['selected'] = isChecked;
    });
    this.updateSelectedIdsFromAll();
  }

  // Verificar si todos los elementos están seleccionados
  isAllSelected(): boolean {
    return this.biblio && this.biblio.length > 0 && this.biblio.every(item => item['selected']);
  }

  // Actualizar arreglo de IDs seleccionados
  updateSelectedIds(item: any): void {
    if (item.selected) {
      if (!this.selectedIds.includes(item.id)) {
        this.selectedIds.push(item.id);
      }
    } else {
      this.selectedIds = this.selectedIds.filter(id => id !== item.id);
    }
  }

  updateSelectedIdsFromAll(): void {
    if (this.isAllSelected()) {
      this.selectedIds = this.biblio.map(item => item.id);
    } else {
      this.selectedIds = [];
    }
  }


  toggleStatusSelected(): void {
    if (this.selectedIds.length === 0) {
      alert('Seleccione al menos un elemento para cambiar su estado.');
      return;
    }
    const selectedItems = this.biblio.filter(item => this.selectedIds.includes(item.id));
    selectedItems.forEach(item => {
      item.status = !item.status;
    });
  }

  deleteBiblio(id: string, num: string) {
    if (confirm('¿Está seguro que desea eliminar la bibliografia numero ' + num + '?')) {
      if (id) {
        this.biblioS.delete(id).subscribe({
          next: res => {
            const params = this.activedRoute.snapshot.params;
            this.getBiblio4t1(params['idtier3']);
          },
          error: err => {
            console.error(err)
          }
        });
      }
    }
  }

  inactiveBiblioBlock(): void {
    if (this.selectedIds.length === 0) {
      alert('No hay elementos seleccionados.');
      return;
    }

    this.biblioS.inactiveBiblioBlock(this.selectedIds).subscribe({
      next: res => {
        alert(res['message']);
        this.selectedIds = [];
        this.getBiblio4t1(this.idtier3Selected)
      },
      error: err => {
        alert('Hubo un error al desactivar los elementos : ' + err);
      }
    });
  }

  getIsBlockedTier3(id: number) {
    this.tier3Service.idT3blocked(id).subscribe({
      next: res => {
        this.isBlockedTier3 = res['isBlocked'];        
      },
      error: err => {
        console.log("Error al verificar el estado de bloqueo: ", err);
      }
    });
  }

}
